/**
 * The SpecialFilterType is defined for filtering entities without defining layers
 */
export enum SpecialFilterType {
  None = 'None',
  PadsDate = 'Pads Date' // 'Pads That Will Expire In Three Months'
}
